import { InviteLinkStatusEnum } from '@synapex/prisma/client'

import selected from './icons/selected.svg?react'
import agreed from './icons/agreed.svg?react'
import waiting_for_documents from './icons/waiting_for_documents.svg?react'
import paid from './icons/paid.svg?react'
import creative_agreed from './icons/creative_agreed.svg?react'
import creative_sent from './icons/creative_sent.svg?react'
import fault from './icons/fault.svg?react'
import posted from './icons/posted.svg?react'

export type StatusContent = {
    value: InviteLinkStatusEnum
    title: string
    Icon: typeof agreed | null
    style: {
        color?: string
        backgroundColor: string
        cursor?: string
    }
    checkStyle?: { color: string }
    allowSelect: boolean
}

export const STATUS_CONTENT: Record<InviteLinkStatusEnum, StatusContent> = {
    no_status: {
        value: 'no_status',
        title: 'Новый',
        Icon: null,
        style: {
            color: '#94A6AF',
            backgroundColor: '#E0E7EE',
        },
        checkStyle: { color: '#056FFF' },
        allowSelect: true,
    },
    in_progress: {
        value: 'in_progress',
        title: 'Отобран',
        Icon: selected,
        style: { backgroundColor: '#64B3FD' },
        allowSelect: true,
    },
    agreed: {
        value: 'agreed',
        title: 'Согласован',
        Icon: agreed,
        style: { backgroundColor: '#C3D84B' },
        allowSelect: true,
    },
    waiting_for_documents: {
        value: 'waiting_for_documents',
        // title: 'Ожидание документов',
        title: 'Ждем документы',
        Icon: waiting_for_documents,
        style: { backgroundColor: '#FFB641' },
        allowSelect: true,
    },
    paid: {
        value: 'paid',
        title: 'Оплачено',
        Icon: paid,
        style: { backgroundColor: '#00A79E' },
        allowSelect: true,
    },
    creative_agreed: {
        value: 'creative_agreed',
        // title: 'Креатив согласован',
        title: 'Крео согласован',
        Icon: creative_agreed,
        style: { backgroundColor: '#5B7CFF' },
        allowSelect: true,
    },
    sent: {
        value: 'sent',
        // title: 'Креатив отправлен',
        title: 'Крео отправлен',
        Icon: creative_sent,
        style: { backgroundColor: '#C77DFF' },
        allowSelect: true,
    },
    delayed: {
        value: 'delayed',
        title: 'Не подходит',
        Icon: fault,
        style: { backgroundColor: '#FF8676' },
        allowSelect: true,
    },
    published: {
        value: 'published',
        title: 'Размещено',
        Icon: posted,
        style: { backgroundColor: '#52D05D', cursor: 'not-allowed' },
        allowSelect: false,
    },
}
